export default "__VITE_ASSET__bVgCoC1x__"